module.exports = __webpack_public_path__ + "img/Monte_Kope_14.913b0aaa.jpg";